import { CLAUDE_FABLE_5_1_MODEL_REFS } from "./claudeFable";

export const BEDROCK_CONVERSE_OPUS_5_5_MODEL_ID =
  "global.anthropic.claude-opus-5-5";
export const BEDROCK_CONVERSE_OPUS_5_5_MODEL_REF =
  "bedrock/global.anthropic.claude-opus-5-5";

/** Exact match on the Claude Opus 5.5 Bedrock Converse ref. */
export function isClaudeOpus55ModelRef(
  modelRef: string | null | undefined,
): boolean {
  return modelRef?.trim() === BEDROCK_CONVERSE_OPUS_5_5_MODEL_REF;
}

/**
 * Claude refs whose request shape is restricted: HTTP 400 for `temperature` /
 * `top_p` / `top_k`, for `tool_choice` other than `auto` / `none`, and for
 * assistant prefill. Fable 5.1 (all three routes) and Opus 5.5 share this
 * contract per their migration guides.
 */
export const CLAUDE_RESTRICTED_REQUEST_MODEL_REFS = [
  ...CLAUDE_FABLE_5_1_MODEL_REFS,
  BEDROCK_CONVERSE_OPUS_5_5_MODEL_REF,
] as const;

const RESTRICTED_REQUEST_REF_SET: ReadonlySet<string> = new Set(
  CLAUDE_RESTRICTED_REQUEST_MODEL_REFS,
);

/** Exact match on one of {@link CLAUDE_RESTRICTED_REQUEST_MODEL_REFS}. */
export function isClaudeRestrictedRequestModelRef(
  modelRef: string | null | undefined,
): boolean {
  const trimmed = modelRef?.trim();
  return trimmed !== undefined && RESTRICTED_REQUEST_REF_SET.has(trimmed);
}
